export const validateMetaLanguage = (dash_es, dash_pt) => {
  let currentUser = JSON.parse(localStorage.getItem("authUser"))
  if (currentUser.language === "pt") {
    return dash_pt
  }
  return dash_es
}